module.exports = __webpack_public_path__ + "img/40_30.be39df22.png";